import { useEffect } from "react";
import { presenceApi } from "../api/presence.api";
import { sessionRecentlyActive } from "../api/session";
import { useAuthStore } from "../store/auth.store";

/** Rythme du signal ; le serveur tient pour « en ligne » un signal de moins de 75 secondes. */
export const PRESENCE_HEARTBEAT_MS = 30_000;
/** Deux signaux à moins de 10 secondes n'apprennent rien au serveur (double montage, retour sur la page). */
const MIN_GAP_MS = 10_000;
/**
 * Rôles qui participent à la messagerie de l'équipe, les seuls que le serveur accepte : super_admin
 * ne signale pas (le serveur le refuse par 403).
 */
const PRESENCE_ROLES = ["owner", "manager", "agent", "read_only", "instructor"];
let lastSent = 0;

/**
 * Signal de présence du compte connecté, tant que la page est visible et que la personne s'en
 * sert (activité des 15 dernières minutes). Page cachée ou poste délaissé : plus de signal, la
 * personne passe hors ligne d'elle-même. Un échec n'est jamais montré.
 */
export function usePresenceHeartbeat() {
  const signedIn = useAuthStore(
    (s) => !!s.token && !!s.user && PRESENCE_ROLES.includes(s.user.role),
  );
  useEffect(() => {
    if (!signedIn) return;
    const beat = () => {
      if (document.visibilityState !== "visible" || !sessionRecentlyActive())
        return;
      if (Date.now() - lastSent < MIN_GAP_MS) return;
      lastSent = Date.now();
      presenceApi.heartbeat().catch(() => undefined);
    };
    beat();
    const timer = window.setInterval(beat, PRESENCE_HEARTBEAT_MS);
    const onVisible = () => {
      if (document.visibilityState === "visible") beat();
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [signedIn]);
}

/** Composant sans rendu, monté une fois dans la mise en page protégée. */
export function PresenceHeartbeat() {
  usePresenceHeartbeat();
  return null;
}
